import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
export function TermsPage() {
  return <div className="min-h-screen bg-[#FAF8F5]" data-id="element-228">
      <div className="max-w-4xl mx-auto px-4 py-16" data-id="element-229">
        <Link to="/" className="inline-flex items-center text-[#C9A227] hover:text-[#3D2314] transition-colors mb-8" data-id="element-230">
          <ArrowLeft className="w-5 h-5 mr-2" data-id="element-231" />
          Volver a la página principal
        </Link>

        <h1 className="text-4xl md:text-5xl font-serif font-bold text-[#3D2314] mb-8" data-id="element-232">
          Términos de Servicio
        </h1>

        <div className="prose prose-lg max-w-none text-[#5C3D2E]" data-id="element-233">
          <p className="text-sm text-[#5C3D2E]/70 mb-8" data-id="element-234">
            Última actualización: Enero 2025
          </p>

          <section className="mb-10" data-id="element-235">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-236">
              1. Identificación del Vendedor
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-237">
              Los productos digitales ofrecidos en esta página son
              comercializados por <strong data-id="element-238">Digital Audible Editorial</strong>.
            </p>
            <p className="mb-4 leading-relaxed" data-id="element-239">
              La venta, procesamiento de pagos y entrega de los productos se
              realiza a través de la plataforma <strong data-id="element-240">Hotmart</strong>, una
              plataforma de distribución de productos digitales reconocida
              internacionalmente.
            </p>
            <p className="leading-relaxed" data-id="element-241">
              Esta página web está alojada en <strong data-id="element-242">MagicPatterns</strong>.
            </p>
          </section>

          <section className="mb-10" data-id="element-243">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-244">
              2. Objeto
            </h2>
            <p className="leading-relaxed" data-id="element-245">
              Los presentes Términos de Servicio regulan la compra y uso del
              pack digital "Genios que Transformaron la Humanidad", que incluye
              libros electrónicos en formato PDF y sus correspondientes
              versiones en audio, sobre las figuras históricas presentadas en
              esta página.
            </p>
          </section>

          <section className="mb-10" data-id="element-246">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-247">
              3. Proceso de Compra
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-248">
              Al hacer clic en "Comprar ahora", será redirigido a la plataforma
              Hotmart donde podrá:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-249">
              <li data-id="element-250">Revisar el contenido del pedido</li>
              <li data-id="element-251">Introducir sus datos de facturación</li>
              <li data-id="element-252">Seleccionar el método de pago</li>
              <li data-id="element-253">Completar la transacción de forma segura</li>
            </ul>
            <p className="leading-relaxed" data-id="element-254">
              Una vez completado el pago, recibirá un correo electrónico con las
              instrucciones para acceder a su contenido digital de forma
              inmediata.
            </p>
          </section>

          <section className="mb-10" data-id="element-255">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-256">
              4. Precio y Forma de Pago
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-257">
              El precio del pack es de <strong data-id="element-258">14,95 €</strong> (impuestos
              incluidos según corresponda).
            </p>
            <p className="leading-relaxed" data-id="element-259">
              Los métodos de pago disponibles son los ofrecidos por Hotmart, que
              pueden incluir: tarjeta de crédito/débito, PayPal, y otros métodos
              según su ubicación geográfica.
            </p>
          </section>

          <section className="mb-10" data-id="element-260">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-261">
              5. Entrega del Producto
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-262">
              Al tratarse de productos digitales, la entrega es inmediata tras
              la confirmación del pago. Recibirá:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-263">
              <li data-id="element-264">Un correo electrónico de confirmación</li>
              <li data-id="element-265">Acceso a su área de miembro en Hotmart</li>
              <li data-id="element-266">Enlaces de descarga para todos los archivos incluidos</li>
            </ul>
          </section>

          <section className="mb-10" data-id="element-267">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-268">
              6. Derecho de Desistimiento
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-269">
              Conforme a la legislación europea sobre contenidos digitales, el
              derecho de desistimiento no será aplicable cuando:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-270">
              <li data-id="element-271">El contenido digital haya sido descargado o accedido</li>
              <li data-id="element-272">
                El consumidor haya dado su consentimiento expreso para que la
                ejecución comience durante el período de desistimiento
              </li>
              <li data-id="element-273">
                El consumidor haya reconocido que pierde su derecho de
                desistimiento una vez ejecutado el contrato
              </li>
            </ul>
            <p className="leading-relaxed" data-id="element-274">
              No obstante, si experimenta problemas técnicos que le impidan
              acceder al contenido, contacte con nosotros para buscar una
              solución.
            </p>
          </section>

          <section className="mb-10" data-id="element-275">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-276">
              7. Licencia de Uso
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-277">
              Al adquirir el pack, usted obtiene una licencia personal,
              intransferible y no exclusiva para:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-278">
              <li data-id="element-279">
                Descargar y almacenar los archivos en sus dispositivos
                personales
              </li>
              <li data-id="element-280">Usar el contenido para su aprendizaje y disfrute personal</li>
            </ul>
            <p className="mb-4 leading-relaxed" data-id="element-281">
              Queda expresamente prohibido:
            </p>
            <ul className="list-disc pl-6 space-y-2 mb-4" data-id="element-282">
              <li data-id="element-283">
                Redistribuir, vender o compartir los archivos con terceros
              </li>
              <li data-id="element-284">Publicar el contenido en plataformas públicas</li>
              <li data-id="element-285">Modificar o crear obras derivadas para uso comercial</li>
              <li data-id="element-286">
                Utilizar el contenido para fines comerciales sin autorización
              </li>
            </ul>
          </section>

          <section className="mb-10" data-id="element-287">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-288">
              8. Propiedad Intelectual
            </h2>
            <p className="leading-relaxed" data-id="element-289">
              Todos los contenidos del pack (textos, diseños, audios, imágenes)
              están protegidos por derechos de propiedad intelectual. Digital
              Audible Editorial se reserva todos los derechos no expresamente
              concedidos en estos términos.
            </p>
          </section>

          <section className="mb-10" data-id="element-290">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-291">
              9. Garantía y Soporte
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-292">
              Garantizamos que los archivos digitales estarán libres de errores
              técnicos que impidan su correcta visualización o reproducción en
              dispositivos estándar.
            </p>
            <p className="leading-relaxed" data-id="element-293">
              Si experimenta cualquier problema técnico, puede contactarnos y le
              proporcionaremos asistencia para resolver la incidencia.
            </p>
          </section>

          <section className="mb-10" data-id="element-294">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-295">
              10. Limitación de Responsabilidad
            </h2>
            <p className="leading-relaxed" data-id="element-296">
              El contenido del pack tiene fines educativos e informativos.
              Digital Audible Editorial no se hace responsable del uso que el
              usuario haga de la información contenida en los materiales, ni de
              los resultados obtenidos de su aplicación.
            </p>
          </section>

          <section className="mb-10" data-id="element-297">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-298">
              11. Legislación Aplicable
            </h2>
            <p className="leading-relaxed" data-id="element-299">
              Estos Términos de Servicio se rigen por la legislación española y
              europea aplicable, incluyendo el Reglamento General de Protección
              de Datos (RGPD), la Ley de Servicios de la Sociedad de la
              Información (LSSI), y la normativa de protección de consumidores y
              usuarios.
            </p>
          </section>

          <section className="mb-10" data-id="element-300">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-301">
              12. Resolución de Conflictos
            </h2>
            <p className="mb-4 leading-relaxed" data-id="element-302">
              Para cualquier controversia derivada de estos términos, las partes
              se someten a los Juzgados y Tribunales del domicilio del
              consumidor, conforme a la legislación europea.
            </p>
            <p className="leading-relaxed" data-id="element-303">
              También puede acceder a la plataforma de resolución de litigios en
              línea de la UE:
              <a href="https://ec.europa.eu/consumers/odr" target="_blank" rel="noopener noreferrer" className="text-[#C9A227] hover:underline ml-1" data-id="element-304">
                https://ec.europa.eu/consumers/odr
              </a>
            </p>
          </section>

          <section data-id="element-305">
            <h2 className="text-2xl font-serif font-bold text-[#3D2314] mb-4" data-id="element-306">
              13. Modificaciones
            </h2>
            <p className="leading-relaxed" data-id="element-307">
              Nos reservamos el derecho de modificar estos Términos de Servicio.
              Las modificaciones entrarán en vigor desde su publicación en esta
              página. Le recomendamos revisar periódicamente estos términos.
            </p>
          </section>
        </div>
      </div>

      <footer className="bg-[#2A180D] text-[#E0D8D0] py-8 text-center border-t border-[#3D2314]" data-id="element-308">
        <div className="max-w-7xl mx-auto px-4" data-id="element-309">
          <p className="text-sm opacity-60" data-id="element-310">
            © 2026 Digital Audible Editorial. Todos los derechos reservados.
          </p>
        </div>
      </footer>
    </div>;
}